import $ from 'jquery'

const getVenuesSettings = () => {
  const selector = 'script[data-drupal-selector="drupal-settings-json"]'
  const drupalSettings = JSON.parse($(selector).html())
  return drupalSettings.venuesSettings
}

export default getVenuesSettings
